import { render, staticRenderFns } from "./TestimoniList.vue?vue&type=template&id=70bf56cf"
import script from "./TestimoniList.vue?vue&type=script&lang=js"
export * from "./TestimoniList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports